import { ALPHA_SERVICES_NAMES, ALPHA_UI_SERVICE_NAMES } from '@alpha-core/alpha-utils/lib/alpha-services-utils';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { SessionTimeoutService } from '../services/session-timeout.service';
const ALPHA_SERVICE_URL_KEYS = [...ALPHA_UI_SERVICE_NAMES, ...ALPHA_SERVICES_NAMES];

const ALPHA_URLS: string[] = ALPHA_SERVICE_URL_KEYS.map((key) => window.environments[key]).filter(
    (url): url is string => !!url,
);

export const sessionResetInterceptor: HttpInterceptorFn = (req, next) => {
    const sessionService = inject(SessionTimeoutService);

    if (ALPHA_URLS.some((baseUrl) => req.url.startsWith(baseUrl))) {
        return next(req).pipe(
            tap({
                next: () => sessionService.resetSession(),
            }),
        );
    }

    if (req.url.startsWith(window.environments.ALPHA_UI_MAKE_REQUEST_URL)) {
        const url = (req.body as any)?.url;

        if (url?.type === 'environment' && ALPHA_SERVICE_URL_KEYS.includes(url.value?.['__alpha_env__'])) {
            return next(req).pipe(
                tap({
                    next: () => sessionService.resetSession(),
                }),
            );
        }

        if (typeof url === 'string' && ALPHA_URLS.some((baseUrl) => url.startsWith(baseUrl))) {
            return next(req).pipe(
                tap({
                    next: () => sessionService.resetSession(),
                }),
            );
        }
    }

    return next(req);
};
